// extracted by mini-css-extract-plugin
export default {"BrokenLink":"CustomPageNotFound_BrokenLink__5yBvZ","InfoText":"CustomPageNotFound_InfoText__zjJaZ"};